<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商城页面设置
      <small>/&nbsp; <router-link to="/topnavsetting" class="TitleStyle"> 导航管理</router-link>/&nbsp;关联商品</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">关联商品列表</h4>
              </div>
              <!-- end panel-heading -->

              <!-- begin panel-body -->
              <div class="panel-body">
              
                <el-table :data="BrandList" border style="width: 100%"  >
      
                 
                  <el-table-column prop="goodsName" label="商品名称" width="150"></el-table-column>
                  <el-table-column label="商品包装率">
                     <template slot-scope="scope">
                      <el-checkbox :label="item.packageRates"  v-for="(item,index) in scope.row.packageRates"  @change="RatesChange(item.check,index,scope.row)" 
                      :key="index" v-model="item.check">{{item.packageRates}}</el-checkbox>
                       


                    </template>
                  </el-table-column>
                 
                </el-table>
                   <div class="swal-footer"> 
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit()"
              :disabled = "disabled"
            >确定</button>
         
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="GoBack()"
            >取消</div>
          </div>
          </div>
        </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
   
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "BannerManagement",
  data() {
    return {
     pageSize:10,
     pageNo:1,
     topMenuId:'',
     disabled: false,
     BrandList:[{

     }],
  
    };
  },
  mounted: function() {
   this.initdata();
  },
  methods: {
    RatesChange(val,index,row){
      if(val){
        row.check = true;
      }else{
        row.packageRates.forEach(element=>{
          //-1代表不存在
          if(element.check.toString().indexOf("true")==-1){
           row.check = false
          }
        })
      }
    
    },
    MakeSureEdit(){
      let that = this;
       that.disabled = true;
     
   
     let count=-1;
      let goodsIdList = [];
     
      this.BrandList.forEach((val,index) =>{

        if(val.check){
            count++;
            goodsIdList.push({goodsId:val.goodsId,packageRates:[]})
             val.packageRates.forEach((element,index2)=>{
              
              if(element.check){
          
                goodsIdList[count].packageRates.push(
                   element.packageRates
                ) 
              }
             })
          
        }
      })
    
         const options = {
        url: "distribution/B2cMarketTopmenuController/updateTopMenusAndGoods",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          topMenuId: that.topMenuId,
          goodsIdList:goodsIdList
        }
      };
      axios(options)
        .then(function(response) {
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata()
           that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                });
          that.$router.push({ name: "TopNavSetting" });
           
          }else{
               http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
            that.disabled = false;
          http.handleHttpError(error, that);
        });
    
   
   
    },
     GoBack(){
      this.$router.push({ name: "TopNavSetting" , params: { pageNo : this.pageNo,pagesize: this.pageSize}});
     },
      initdata(){
           
     if(localStorage.getItem('goodlist')){
       let goodlist =localStorage.getItem('goodlist')
       this.pageNo = JSON.parse(goodlist).pageNo;
       this.pageSize = JSON.parse(goodlist).pageSize;
       this.topMenuId = JSON.parse(goodlist).row.topMenuId;
    }  
    let that = this;
         const options = {
        url: "distribution/B2cMarketTopmenuController/queryAllGoods",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          topMenuId: JSON.parse(localStorage.getItem('goodlist')).row.topMenuId,
        })
      };
      axios(options)
        .then(function(response) {
   
          if (response.data.code == 200) {
             that.BrandList = response.data.data;
             
          }else{
                http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
      }
   
  
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.TitleStyle {
  color: #6a7786;
}
</style>



// WEBPACK FOOTER //
// src/components/PCMallManage/RelatedGoods.vue